import React from 'react';

import { Container, GlobalCss } from './landing.styles';

import bannerImg from 'resource/img/illustrations/thoughts.svg';
import Navbar from 'component/landing/navbar';
import OurServices from 'component/landing/our-services';
import BannerCallToAction from 'component/landing/banner-call-to-action';
import BannerVideo from 'component/landing/banner-video';
import RecommendedPosts from 'component/landing/recommended-posts';

import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Roboto'],
  },
});

function Landing() {
  return (
    <>
      <Navbar />

      <Container>
        <BannerCallToAction
          info={{
            title: <>Alavanque seu escritório no Juslabore</>,
            description: `É muito fácil expandir suas possibilidades no Direito Trabalhista. 
            Venha conhecer o que nossa plataforma pode prover aos advogados 4.0`,
          }}
          bannerImg={bannerImg}
          action={{
            buttonText: 'Teste Grátis',
            to: '/acesso',
          }}
        />

        <OurServices />

        <BannerVideo
          title="Vídeo tutorial de como utilizar o Recorte"
          action={{
            buttonText: 'Teste Grátis',
            to: '/acesso',
          }}
          videoSrc="https://www.youtube.com/embed/IHCE2RWNEQg"
        />

        <RecommendedPosts />
      </Container>
      <GlobalCss />
    </>
  );
}

export default Landing;
